<template>
    <section class="top-brands-wrap clearfix mt-4">
        <div class="container">
            <FeaturedGridSkeleton v-if="!isFetchingTopBrands"></FeaturedGridSkeleton>
            <div v-else>
                <div class="d-flex align-items-center justify-content-between mb-2">
                    <h2 class="section-title">Thương hiệu nổi bật</h2>
                </div>
                <div class="top-brands clearfix" ref="topBrands">
                    <div v-for="(topBrand, index) in topBrands" :key="index" class="top-brand-item">
                        <div class="top-brand-banner">
                            <a :href="topBrand.url">
                                <img width="50" :src="topBrand.banner.path" alt="brand banner">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import FeaturedGridSkeleton from './SkeletonLoader/FeaturedGridSkeleton.vue';

    export default {
        props: [],
        components: { FeaturedGridSkeleton },
        data() {
            return {
                topBrands: [],
                isFetchingTopBrands: false,
            };
        },
        created() {
            $.ajax({
                method: 'GET',
                url: route('ecommerce.home.top_brands.index'),
            }).then((response) => {
                this.topBrands = response;

                this.isFetchingTopBrands = true;

                this.$nextTick(() => {
                    $(this.$refs.topBrands).slick(this.slickOptions());
                });
            }).catch((xhr) => {
                this.fetchingProductsByCategory = false;
                this.$notify(xhr.responseJSON.message);
            });
        },

        methods: {
            slickOptions() {
                return {
                    dots: false,
                    arrows: true,
                    infinite: false,
                    slidesToShow: 10,
                    slidesToScroll: 10,
                    rtl: window.FleetCart.rtl,
                    responsive: [
                        {
                            breakpoint: 1440,
                            settings: {
                                slidesToShow: 8,
                                slidesToScroll: 8,
                            },
                        },
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 6,
                                slidesToScroll: 6,
                            },
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 5,
                                slidesToScroll: 5,
                            },
                        },
                        {
                            breakpoint: 768,
                            settings: {
                                arrows: false,
                                slidesToShow: 4.2,
                                slidesToScroll: 4,
                            },
                        },
                        {
                            breakpoint: 600,
                            settings: {
                                arrows: false,
                                slidesToShow: 3.4,
                                slidesToScroll: 3,
                            },
                        },
                    ],
                };
            },
        },
    };
</script>
